"use client";

import { ArrowLeftIcon } from "@heroicons/react/24/solid";
import { useClientConfig } from "@providers/app-provider/client-app-provider";
import Image from "next/image";
import Link from "next/link";
import { HeaderUserPopup } from "./popup/header-user-popup";
import { Button, Dialog, DialogBody, DialogClose, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@ubud-ui/react-ui-kit";

export function SimpleHeader() {
  const clientConfig = useClientConfig();
  const config = clientConfig?.layoutSetting;
  const user = clientConfig?.user;

  return (
    <header>
      <nav className="border-b border-gray-100 bg-white z-50 fixed w-full top-0 left-0">
        <div className="px-4 md:px-6 container">
          <div className="flex h-[76px] w-full justify-between gap-2 md:gap-6 items-center relative">
            <Dialog>
              <DialogTrigger asChild>
                <a className="text-sm font-bold text-gray-500 cursor-pointer">
                  <span className="hidden md:inline-block">Kembali ke Halaman Utama</span>
                  <ArrowLeftIcon className="size-5 min-w-5 md:hidden" />
                </a>
              </DialogTrigger>
              <DialogContent>
                <DialogHeader>
                  <DialogTitle className="font-bold text-lg">Keluar ke halaman utama</DialogTitle>
                </DialogHeader>
                <DialogBody>
                  <div>
                    <p className="text-sm font-normal text-gray-500">
                      Semua data yang sudah diisi akan hilang. Apakah Anda yakin ingin keluar?
                    </p>
                    <div className="flex items-center justify-end text-right gap-3 mt-6">
                      <DialogClose asChild>
                        <Button variant="outline" className="text-sm font-bold">
                          Lanjutkan Daftar
                        </Button>
                      </DialogClose>
                      <Button variant="destructive" className="text-sm font-bold" asChild>
                        <Link href="/">Keluar</Link>
                      </Button>
                    </div>
                  </div>
                </DialogBody>
              </DialogContent>
            </Dialog>
            <Link href="/" className="absolute left-[50%] transform translate-x-[-50%]">
              <Image
                src={config?.header?.logo?.url || "/blank-white.webp"}
                alt={config?.header?.logo?.alternativeText || config?.header?.logo?.name || "Karirhub oleh Kemnaker"}
                className="w-[144px] h-auto inline-block"
                width={config?.header?.logo?.width || 144}
                height={config?.header?.logo?.height || 36}
              />
            </Link>
            <div className="flex items-center justify-end gap-4">
              {config && !!user && (
                <div>
                  <HeaderUserPopup />
                </div>
              )}
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
}
